import React, { Component } from 'react';
import Episode from './Episode';
import axios from '../../utils/axios/spotify-api';

class Episodes extends Component {
	state = {
		episodes: []
	};

	componentDidMount() {
		axios.get('/episodes')
			.then(response => {
				this.setState({ episodes: Array.isArray(response.data) ? response.data : [] });
			});
	}

	getFiltered() {
		const episodes = Array.isArray(this.state.episodes) ? this.state.episodes : [];
		const q = (this.props.query || '').trim().toLowerCase();
		const list = episodes
			.map((ep, i) => ({ ep, i }))
			.filter(({ ep }) => ep != null)
			.filter(({ ep }) =>
				!q ||
				(ep.episode || '').toLowerCase().includes(q) ||
				(ep.desc || '').toLowerCase().includes(q)
			);

		// On the detail page (limit set) show only the next `limit` episodes
		// after the current one, wrapping around so the grid is always full.
		// While searching, ignore the limit so results span all episodes.
		const { limit, fromId } = this.props;
		if (limit && !q) {
			const current = Number(fromId);
			const after = list.filter(({ i }) => i > current);
			const before = list.filter(({ i }) => i < current);
			return after.concat(before).slice(0, limit);
		}
		return list;
	}

	render() {
		const filtered = this.getFiltered();

		return (
			<main className="flex-1 max-w-container-max mx-auto w-full px-margin-mobile md:px-margin-desktop py-12 flex flex-col gap-12">
				{/* Header */}
				<section className="flex flex-col items-center gap-8">
					<h2 className="font-headline-xl text-headline-xl text-on-surface text-center">{this.props.title}</h2>
				</section>

				{/* Episode Grid */}
				<section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-gutter">
					{filtered.map(({ ep, i }) => (
						<Episode
							key={i}
							id={i}
							name={ep.episode}
							description={ep.desc}
							imageUrl={ep.cover}
							category={ep.categories}
							episodeUrl={ep.episodeUrl}
						/>
					))}
				</section>
			</main>
		);
	}

}
export default Episodes;
